export enum DevToolsCommandType {
  TerminateEtlBatch = 1,
  TerminateLoanValidation = 2,
  ImportAllIfxLoans = 3,
  ImportAllIfxBankJob = 4,
  ImportLoansByIds = 5,
  RemoveAllLoanByProgram = 6,
  ImportAllLenderPayments = 7,
  LoadLoans = 8,
}

export enum ESystemFlowMode {
  Event = 1,
  Master = 2,
}

export interface FinancingProgramSystemFlowMode {
  financingProgramId: string
  mode: ESystemFlowMode
}

export interface SystemFlowModes {
  financingPrograms: FinancingProgramSystemFlowMode[]
}

export interface DevToolsCommandExecution {
  id: number
  commandType: DevToolsCommandType
  errorMessage: string | null
  executedByUserId: number
  executedByUserFullname: string
  executedOn: string
}
